import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Divider } from '@material-ui/core';
import { NavLink} from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';



const styles = theme => ({
  navListItem:{
    padding: '0px 16px',
    fontSize: '1rem',
    fontWeight: '100',

    [theme.breakpoints.up('sm')]: {
      fontSize: '20px',
      fontWeight: '500',
    },
   
    '&:hover':{
      backgroundColor: 'inherit',
     }
  },
  navLink:{
    color: '#fff',
    textDecoration:'none',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    textTransform: 'capitalize',
    color:'#9e9e9e',
    '&:hover':{
      color: '#fff',
     }
  },
  navButtonActive:{
   
    [theme.breakpoints.up('sm')]: {
      borderBottom: '4px solid #fff',
    },
    
    borderRadius: 0,
    color:'#fff'
  },
  
});


const navbarItem = ["webapp","portfolio","contact"];


function Navbar(props) {
  const { classes } = props;
  return (
    <Fragment>
      {
        navbarItem.map((item) =>(
              <ListItem button key={item} className={classes.navListItem}>
                  <NavLink activeClassName={classes.navButtonActive} className={classes.navLink}   to={"/"+item} >{item}</NavLink>
              </ListItem>      
            ))
           
        }
    
    </Fragment>
    
  );
}


 {/* <ul className={classes.navList}>
        {
          navbarItem.map((item, index) =>(
            <li className={classes.navListItem} key={index}><NavLink  activeClassName={classes.navButtonActive} className={classes.navLink} to={"/"+item} >{item}</NavLink></li>
            
          ))
        }
    </ul> */}

Navbar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles,{withTheme:true})(Navbar);









// WEBPACK FOOTER //
// ./src/component/layouts/navbar.js